import { AxiosResponse } from "axios";
import PagedResponse from "../models/PagedResponse";
import Api from "./Api";
import CustomerResponse from "../models/customer/Customer.response";
import CountryResponse from "../models/country/Country.response";
import ApiResponse from "../models/ApiResponse";
import TestRequestResponse from "../models/test-request/TestRequestResponse";

class BackgroundInformationApi {
  constructor(private api: Api) {}

  public createBackgroundInformation(
    payload: TestRequestRaw.Schemas.CreateTestRequestRQ,
  ): ApiResponse<TestRequestResponse> {
    return this.api.post("/test-request/v2/testrequests", payload);
  }

  public updateBackgroundInformationTitle(
    id: string,
    newTitle: string,
  ): Promise<AxiosResponse<TestRequestRaw.Schemas.TestRequestResponse>> {
    return this.api.patch(`/test-request/v2/testrequests/${id}`, newTitle);
  }

  public updateBackgroundInformation(
    id: string,
    payload: TestRequestRaw.Schemas.TestRequestDescriptionRq,
  ): ApiResponse<TestRequestResponse> {
    return this.api.put(`/test-request/v2/testrequests/${id}`, payload);
  }

  public searchCustomers(
    countryId = 0,
    customerName = "",
    pageIndex = "0",
    pageSize = "150",
    sortDirection = "ASC",
  ): ApiResponse<PagedResponse<CustomerResponse>> {
    const params = new URLSearchParams();

    if (countryId !== 0) {
      params.append("countryId", countryId.toString());
    }

    params.append("customerName", customerName);
    params.append("pageIndex", pageIndex);
    params.append("pageSize", pageSize);
    params.append("sortDirection", sortDirection);

    return this.api.get("/test-request/customer", { params });
  }

  public findCountry(countryName: string): Promise<AxiosResponse<CountryResponse>> {
    return this.api.get(`/test-request/country/find?name=${encodeURIComponent(countryName)}`);
  }

  public findCustomer(countryName: string, customerName: string): Promise<AxiosResponse<CustomerResponse>> {
    return this.api.get(
      `/test-request/customer/find?countryName=${encodeURIComponent(countryName)}&customerName=${encodeURIComponent(
        customerName,
      )}`,
    );
  }

  public searchCustomerByCrmAccountNumber(accountNumber: string): ApiResponse<CustomerResponse> {
    return this.api.get(`/test-request/customer/account/${accountNumber}`);
  }

  public searchLocations(
    searchString: string,
    pageIndex = "0",
    pageSize = "25",
    sortDirection = "ASC",
  ): ApiResponse<PagedResponse<CountryResponse>> {
    const params = new URLSearchParams([
      ["name", searchString],
      ["pageIndex", pageIndex],
      ["pageSize", pageSize],
      ["sortDirection", sortDirection],
    ]);
    return this.api.get("/test-request/country", { params });
  }

  public searchOems(searchString: string): Promise<AxiosResponse<PagedResponse<TestRequestRaw.Schemas.OemResponse>>> {
    return this.api.get(`/test-request/v2/oem?term=${encodeURIComponent(searchString)}`);
  }
}

export default BackgroundInformationApi;
